'use client';

import { useEffect } from 'react';
import { trackArticleView } from '@/lib/analytics';

interface ArticleViewTrackerProps {
  title: string;
  slug: string;
  category?: string;
  tags?: string[];
  contentType?: string;
  author?: string;
}

/**
 * Client component that tracks article page views
 * Use this in server components to track page visits
 */
export default function ArticleViewTracker({
  title,
  slug,
  category,
  tags,
  contentType,
  author,
}: ArticleViewTrackerProps) {
  useEffect(() => {
    // Track the article view when component mounts
    trackArticleView({
      title,
      slug,
      category,
      tags,
      contentType,
      author,
    });
  }, [title, slug, category, tags, contentType, author]);

  // This component doesn't render anything
  return null;
}


